import { Circle, Fill, Stroke, Style } from 'ol/style';
import Feature from 'ol/Feature';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import 'ol/ol.css';
import Draw from 'ol/interaction/Draw';
import {Modify, Translate} from 'ol/interaction';
import Polygon from 'ol/geom/Polygon';
import Collection from 'ol/Collection';
import { never } from 'ol/events/condition';
import Point from 'ol/geom/Point';

export default class RectangleAnnotation{

    constructor(){

        this.featureStyleFunction = () => {
            return new Style({
                fill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                    opacity: 0
                }),
                stroke: new Stroke({
                    color: '#8c0d4c',
                    width: 2
                }),
                image: new Circle({
                    radius: 7,
                    fill: new Fill({
                    color: '#8c0d4c'
                    })
                })
            });
        };

        this.modifyStyleFunction = () => {
            const style = new Style({
                fill: new Fill({
                    color: 'rgba(0,0,255,0.3)'
                }),
                stroke: new Stroke({
                    color: '#ffcc33',
                    width: 2
                }),
                image: new Circle({
                    radius: 7,
                    fill: new Fill({
                    color: '#ffcc33'
                    })
                }),
            });
            return style;
            
        };
        this.source = new VectorSource({});
        this.layer = new VectorLayer({
            opacity: 100,
            visible: true,
            source: this.source,
            style: this.featureStyleFunction,
            zIndex: 2,
        });
        this.modify = null;
        this.map = null;
        this.onEnd = null;
        this.draw = null;
        this.copiedCoordinate =[];
        this.copyDraw = new Draw({
            condition: never,
            style: new Style ({
                renderer: (pixelCoordinates, state) => {
                    const centerPoint = this.map.getCoordinateFromPixel(pixelCoordinates);

                    const c1 = [centerPoint[0] + this.copiedCoordinate[0][0], centerPoint[1] + this.copiedCoordinate[0][1]];
                    const c2 = [centerPoint[0] + this.copiedCoordinate[1][0], centerPoint[1] + this.copiedCoordinate[1][1]];
                    const c3 = [centerPoint[0] + this.copiedCoordinate[2][0], centerPoint[1] + this.copiedCoordinate[2][1]];
                    const c4 = [centerPoint[0] + this.copiedCoordinate[3][0], centerPoint[1] + this.copiedCoordinate[3][1]];

                    const p1 = this.map.getPixelFromCoordinate(c1);
                    const p2 = this.map.getPixelFromCoordinate(c2);
                    const p3 = this.map.getPixelFromCoordinate(c3);
                    const p4 = this.map.getPixelFromCoordinate(c4);

                    const ctx = state.context;
                    ctx.strokeStyle = '#00aeff';
                    ctx.lineWidth = 3;
                    ctx.beginPath();
                    ctx.moveTo(p1[0], p1[1]);
                    ctx.lineTo(p2[0], p2[1]);
                    ctx.lineTo(p3[0], p3[1]);
                    ctx.lineTo(p4[0], p4[1]);
                    ctx.closePath();
                    ctx.stroke();
                }
            })
        });

        this.translate = null;
        
    }

    drawPolygonOnMap(array_coordinate) {
        const features = this.layer.getSource().getFeatures();
        features.forEach((feature) => {
            this.layer.getSource().removeFeature(feature);
        });
        const lonLatFeatures = []; 
        array_coordinate.forEach(element => {
            const id = element["Id"];
            const p1 = [element["points"][0]['POINT_X'], element["points"][0]['POINT_Y']];
            const p2 = [element["points"][1]['POINT_X'], element["points"][1]['POINT_Y']];
            const p3 = [element["points"][2]['POINT_X'], element["points"][2]['POINT_Y']];
            const p4 = [element["points"][3]['POINT_X'], element["points"][3]['POINT_Y']];

            const pnt= [];
            pnt.push(p1,p2,p3,p4,p1);

            const pf = new Polygon([pnt]);

            var marker = new Feature({
                geometry: pf,
                type: 'Polygon',
                id: id
            });
            marker.setStyle(this.featureStyleFunction);
            marker.setId(id);
            
            lonLatFeatures.push(marker);
        });
        this.layer.getSource().addFeatures(lonLatFeatures);
    }

    setModifyTranslate(map, feature, onEnd) {
        this.onEnd = onEnd;
        this.map = map;
        const listCoordinates = feature.getGeometry().getCoordinates()[0];

        this.map.removeInteraction(this.modify);
        this.modify = new Modify({
            features: new Collection([feature]),
            pixelTolerance: 10,
            insertVertexCondition: never,
            style: new Style({
                image: new Circle({
                    radius: 5,
                    fill: new Fill({
                      color: '#3492eb'
                    })
                  }),
                geometry: (feature) => {
                    var coordinates = feature.getGeometry().getCoordinates();
                    let point = [];
                    listCoordinates.forEach(element => {
                        if (element[0] === coordinates[0] && element[1] === coordinates[1]) {
                            point = coordinates;
                        }
                    });
                    return new Point(point);
                }
            }),
        });

        this.modify.on('modifyend', (evt) => {
            const features = evt.features.item(0);
            if (features) {
                this.onEnd(features); 
            }
        });

        this.map.removeInteraction(this.translate);
        this.translate = new Translate({
            features: new Collection([feature]),
        });
        this.translate.on('translateend', (evt) => {
            const features = evt.features.item(0);
            this.onEnd(features); 
        });
        this.map.getInteractions().extend([this.translate, this.modify]);
    }

    newFeature(info) {
        const id = info["Id"];
        const listPoint = [];
        info["points"].forEach(element => {
            const point = [element['POINT_X'], element['POINT_Y']];
            listPoint.push(point);
        });
        listPoint.push(listPoint[0]);
        const pf = new Polygon([listPoint]);
        const feature = new Feature({
            geometry: pf,
            type: 'Polygon',
            id: id,
        });
        feature.setId(id);
        return feature;
    }

    addNewFeature(info) {
        const feature = this.newFeature(info.coordinates);
        this.layer.getSource().addFeature(feature);
    }

    removeFeature(features) {
        features.forEach(info => {
            const id = info.getId();
            const feature = this.layer.getSource().getFeatureById(id);
            if (feature) {
            this.layer.getSource().removeFeature(feature);
            }
        });
    }
    changeTypePoint(map, type_point) {
        this.map = map;
        this.map.removeInteraction(this.draw);
        if(type_point === "box"){
            this.geometryFunction = (coordinates, geometry) => {
                if (!geometry) {
                    geometry = new Polygon([[]]);
                }
                const start = coordinates[0];
                const end = coordinates[1];
                geometry.setCoordinates([
                [start, [start[0], end[1]], end, [end[0], start[1]], start]
                ]);
                return geometry;
            };
            this.draw = new Draw({
                source: new VectorSource(),
                type: 'LineString',
                geometryFunction: this.geometryFunction,
            });
        }else{
            
            this.draw = new Draw({
                source: new VectorSource(),
                type: 'Polygon',
            });
        }
        this.map.addInteraction(this.draw);
    }
}
